import { parseBytes16String, parseBytes32String } from './etherUtils';

const formatAddress = (address: string) => `${address.slice(0, 5)}...${address.slice(-4)}`;

const formatBalance = (balance: string) => balance.slice(0, 5);

function capitalizeWords(str: string) {
  if (!str) return;
  const arr = str.split(' ');
  const capitalizedArr = arr.map((element) => {
    return element.charAt(0).toUpperCase() + element.slice(1).toLowerCase();
  });
  return capitalizedArr.join(' ');
}

const groupBy = function (xs: any[], key: string) {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
};

export { formatAddress, formatBalance, capitalizeWords, groupBy };
